import { AccredibleAuthenticationApiService } from '@accredible-frontend-v2/services/authentication';
import { AccredibleCookiesService } from '@accredible-frontend-v2/services/cookies';
import { AccredibleUserApiService } from '@accredible-frontend-v2/services/user';
import { Injectable } from '@angular/core';
import { CanActivate, Router, UrlTree } from '@angular/router';
import { Store } from '@ngrx/store';
import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';
import * as AuthorizedActions from '../../../core/stores/authorized/authorized.actions';
import { AuthorizedState } from '../../../core/stores/authorized/authorized.reducer';

@Injectable({
  providedIn: 'root',
})
export class NotAuthenticatedGuard implements CanActivate {
  // TODO(LuísF): When this guard is moved to the accounts domain lib, add it to the CompleteYourProfileRoutes file

  constructor(
    private readonly _router: Router,
    private readonly _authorizedStore: Store<AuthorizedState>,
    private readonly _authenticationApi: AccredibleAuthenticationApiService,
    private readonly _userApi: AccredibleUserApiService,
    private readonly _cookies: AccredibleCookiesService,
  ) {}

  canActivate(): Observable<UrlTree | boolean> {
    if (this._authenticationApi.getSessionToken()) {
      if (this._userApi.isUserSignedIn()) {
        // User is logged in, go to settings
        return of(this._router.createUrlTree(['settings']));
      }

      // User is logged in, but we haven't got the user data
      // This happens when a user logs in another tab
      return this._authenticationApi.checkSession().pipe(
        map((user) => {
          this._authorizedStore.dispatch(AuthorizedActions.setUser({ user }));
          return this._router.createUrlTree(['settings']);
        }),
      );
    }

    // User is not logged in
    return of(true);
  }
}
